import { useEffect, useState } from 'react';

import { CloseIcon } from '../../../../../assets/icons/CloseIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { delay } from '../../../../../utils/delay';
import { ModalProps } from '../types/distribuicaoTypes';
import { ContentModalRedistribuicao } from './ContentModalRedistribuicao';
import { TableModal } from './TableModal';
import { TableModalEquipe } from './TableModalEquipeRedistribuicao';
import { Toast } from './Toast';

export const ModalRedistribuicao = ({
  onClose,
  data,
  apiGestaoLeads,
  disponiveis
}: ModalProps) => {
  const [sellers, setSellers] = useState(data);

  const [vendedorRetirar, setVendedorRetirar] = useState<any>({
    nome: 'Selecione um vendedor',
    leads_usuario: {}
  });

  const [vendedorReceber, setVendedorReceber] = useState<any>({
    nome: 'Selecione um vendedor',
    leads_usuario: {}
  });

  const [originSeller, setOriginSeller] = useState('Selecionar Vendedor');
  const [originSellerId, setOriginSellerId] = useState('');
  const [destinationSeller, setDestinationSeller] = useState(
    'Selecionar Vendedor'
  );

  const [leadsToTransfer, setLeadsToTransfer] = useState(0);

  const [teamsSelected, setTeamsSelected] = useState(false);
  const [sellersSelected, setSellersSelected] = useState(true);

  const [originDropdownSelected, setOriginDropdownSelected] = useState(false);
  const [destinationDropdownSelected, setDestinationDropdownSelected] =
    useState(false);

  const [showToast, setShowToast] = useState(false);
  const [messageToast, setMessageToast] = useState('');
  const [typeMessage, setTypeMessage] = useState<
    'error' | 'warn' | 'success' | ''
  >('');

  const handleVendedorRetirar = (id_vendedor: string) => {
    const arrayVendedores = data.map((item: any) => {
      return { ...item };
    });

    const vendedorSelecionado = arrayVendedores.find((vendedorAtual: any) => {
      return vendedorAtual.id === id_vendedor;
    });

    setVendedorRetirar(vendedorSelecionado);
  };

  const handleVendedorReceber = (id_vendedor: any) => {
    const vendedoresAtivos = data.filter(
      (vendedor: any) => vendedor.status === 'ativo'
    );
    const arrayVendedores = vendedoresAtivos.map((item: any) => ({ ...item }));

    const vendedorSelecionado = arrayVendedores.find(
      (vendedorAtual: any) => vendedorAtual.id === id_vendedor
    );

    setVendedorReceber(vendedorSelecionado);
  };

  const handleRedistribuicao = async () => {
    if (leadsToTransfer === 0) {
      handleShowToast(
        'open',
        'Digite uma quantidade de leads para retirar',
        'warn'
      );
      return;
    }

    let body = {
      vendedor_retira:
        vendedorRetirar.tipo === 'gestor' ? null : vendedorRetirar.id,
      vendedor_recebe:
        vendedorReceber.tipo === 'gestor' ? null : vendedorReceber.id,
      quantidade: leadsToTransfer
    };
    const limit = 10;
    let count = 1;
    const offset = 0;
    try {
      while (count > 0) {
        const { data } = await apiSensedia.put(
          '/oportunidades-sulamerica/painel-leads/redistribuicoes',
          body,
          {
            timeout: 0,
            params: { limit, offset }
          }
        );

        body = data;
        count = data.quantidade;
      }
      await handleShowToast(
        'open',
        'Leads redistribuídos com sucesso',
        'success'
      );

      await delay(4000);
    } catch (err) {
      await setTypeMessage('error');
      handleShowToast(
        'open',
        'Ocorreu um erro, favor tente novamente',
        'error'
      );

      console.log(err);
    }
  };

  const sumLeadsNaCarteira = (obj) =>
    Object.entries(obj).reduce((sum, [key, value]) => {
      if (key === 'concluidos') return 0;
      if (Array.isArray(value)) {
        return sum + value.length;
      } else if (typeof value === 'object') {
        return sum + sumLeadsNaCarteira(value);
      }
      return sum;
    }, 0);

  const handleDropdownSelected = (input: string) => {
    if (input === 'origin') {
      setOriginDropdownSelected(!originDropdownSelected);
    } else if (input === 'destination') {
      setDestinationDropdownSelected(!destinationDropdownSelected);
    }
  };

  const handleChangeLeadsToTransfer = (value: number) => {
    setLeadsToTransfer(value);
  };

  const handleChangeOriginSeller = (seller: any) => {
    setOriginSeller(seller.nome);
    setOriginSellerId(seller.id);
    handleVendedorRetirar(seller.id);
    setOriginDropdownSelected(false);
  };

  const handleChangeDestinationSeller = (seller: any) => {
    if (seller.nome === originSeller) {
      handleShowToast(
        'open',
        'Selecione outro vendedor para enviar os leads',
        'warn'
      );
    } else {
      setDestinationSeller(seller.nome);
      handleVendedorReceber(seller.id);
      setDestinationDropdownSelected(false);
    }
  };

  const handleTeamsChange = () => {
    setTeamsSelected(true);
    setSellersSelected(false);
  };

  const handleSellersChange = () => {
    setSellersSelected(true);
    setTeamsSelected(false);
  };

  const handleShowToast = async (
    action: 'open' | 'close',
    message?: string,
    type?: 'error' | 'warn' | 'success'
  ) => {
    if (action === 'open') {
      await setMessageToast(message);
      await setTypeMessage(type);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);

        if (type === 'success') {
          window.location.reload();
          onClose();
        }
      }, 3000);
    } else {
      setShowToast(false);
    }
  };

  const objForContentModal = {
    sellers,
    disponiveis,
    originSeller,
    originSellerId,
    destinationSeller,
    originDropdownSelected,
    destinationDropdownSelected,
    handleDropdownSelected,
    handleChangeLeadsToTransfer,
    handleChangeDestinationSeller,
    handleShowToast,
    handleRedistribuicao,
    onClose
  };

  const fetchData = async () => {
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/vendedores-ativos`,
        {
          timeout: 0
        }
      );
      const sortVendedores = data.perfis.sort((a, b) => {
        if (a.nome < b.nome) {
          return -1;
        }
        if (a.nome > b.nome) {
          return 1;
        }
        return 0;
      });

      const withoutGestor = sortVendedores.filter(
        (vendedor: any) => vendedor?.tipo !== 'gestor'
      );
      setSellers(withoutGestor);
      setTypeMessage('');
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="tw-fixed tw-inset-0 tw-z-50 tw-bg-white md:tw-bg-black md:tw-opacity-30"></div>
      <div className="tw-absolute tw-w-full md:tw-w-auto tw-inset-y-0 tw-right-0 tw-bg-[#ffffff] md:tw-rounded-l-[25px] tw-z-50">
        <div className="tw-px-[16px] tw-py-[20px] md:tw-p-[30px] tw-flex tw-justify-between">
          <h2 className="tw-text-[1.25rem] md:tw-text-[1.5rem] tw-leading-[2rem] tw-font-bold">
            Redistribuição manual de leads
          </h2>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-mb-[20px]" />
        <div className="tw-flex tw-justify-between tw-mx-[16px]  md:tw-mx-[30px] tw-py-[20px] tw-px-[20px] md:tw-px-[40px] tw-rounded-[20px] tw-bg-[#F4F4F4]">
          <div className="tw-text-center">
            <p className="tw-whitespace-nowrap tw-min-w-[50%] md:tw-min-w-[150px]">
              Total de Vendedores:
            </p>
            <span className="tw-text-[2.5rem] tw-font-bold">
              {sellers.length}
            </span>
          </div>
          <div className="tw-bg-[#D2D2D2] tw-w-[1px] tw-ml-[20px] tw-mr-[30px] tw-text-transparent">
            div
          </div>
          <div className="tw-text-center ">
            <p className="tw-whitespace-nowrap tw-min-w-[50%] md:tw-min-w-[150px]">
              Total de Leads:
            </p>
            <span className="tw-text-[2.5rem] tw-font-bold">{disponiveis}</span>
          </div>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-[20px] tw-p-[30px]">
          <button
            className="tw-w-full tw-text-[#FFFFFF] tw-py-[13px] tw-rounded-[134px] tw-bg-[#001E64]"
            onClick={() => (window.location.href = '/corretor/leads/perfis')}
          >
            Cadastrar novo vendedor
          </button>
          <button
            className="tw-w-full tw-text-[#FFFFFF] tw-py-[13px] tw-rounded-[134px] tw-bg-[#2A4E9A]"
            onClick={() =>
              (window.location.href = '/corretor/leads/configuracoes')
            }
          >
            Configurações
          </button>
        </div>
        <hr className="tw-bg-[#D2D2D2] tw-h-[1px] tw-mb-[20px]" />
        <h2 className="tw-font-bold tw-text-[1.25rem] tw-leading-[2rem]  tw-px-[16px] md:tw-px-[30px]">
          Selecione um modelo de envio:
        </h2>
        {/* <div
          className={`tw-flex tw-w-full tw-flex-col tw-px-[16px] md:tw-px-[30px] tw-gap-5 tw-text-[#001E64] ${
            teamsSelected
              ? 'tw-bg-[#F5F5F5] tw-py-[30px]'
              : 'tw-bg-[#FFFFFF] tw-py-[20px]'
          } `}
        >
          <span className="tw-flex tw-gap-1">
            <input
              type="radio"
              name="redistribuicao"
              checked={teamsSelected}
              onChange={handleTeamsChange}
            />
            <label>Redistribuição de leads para equipes específicas</label>
          </span>
          <div>
            {teamsSelected && (
              <>
                <TableModalEquipe handleShowToast={handleShowToast} />
              </>
            )}
          </div>
        </div> */}

        <div
          className={`tw-rounded-bl-[25px] tw-bg-[#FFFFFF] ${
            originDropdownSelected ? 'tw-py-[30px]' : 'tw-p-0'
          }
          }`}
        >
          <div
            className={`${
              sellersSelected && 'tw-bg-[#F5F5F5] tw-py-[30px]'
            } tw-px-[16px] md:tw-px-[30px] ${
              !originDropdownSelected && 'tw-rounded-bl-[25px]'
            }`}
          >
            <span className="tw-flex tw-items-center tw-gap-[5px] tw-text-[#001E64]">
              <input
                type="radio"
                name="redistribuicao"
                checked={sellersSelected}
                onChange={handleSellersChange}
              />
              <label>Redistribuição de leads para vendedores específicos</label>
            </span>
            {sellersSelected && (
              <>
                <ContentModalRedistribuicao
                  objForContentModal={objForContentModal}
                />
              </>
            )}
          </div>
          {originDropdownSelected && (
            <div className="tw-px-[16px] md:tw-px-[30px]">
              <TableModal
                data={sellers}
                identification={'redistribuicao'}
                handleChangeSeller={handleChangeOriginSeller}
              />
            </div>
          )}
          {showToast && (
            <Toast
              typeMessage={typeMessage}
              message={messageToast}
              onClose={handleShowToast}
            />
          )}
        </div>
      </div>
    </>
  );
};
